<mat-expansion-panel
  class="app-expansion-panel"
  (afterExpand)="expand.emit(true)"
  (afterCollapse)="expand.emit(false)"
>
  <mat-expansion-panel-header [attr.aria-label]="a11yTitle() | translate">
    <mat-panel-title class="app-title" [attr.aria-hidden]="true">
      {{ title() | translate }}</mat-panel-title
    >
  </mat-expansion-panel-header>
  <ng-content></ng-content>
  <button
    mat-button
    class="app-expansion-panel__toggle app-button app-button--bold"
    (click)="panel.close()"
  >
    {{ "Close" | translate }}
  </button>
</mat-expansion-panel>
